import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/station/co2.svg'
import _imports_1 from '@/assets/station/tree.svg'
import _imports_2 from '@/assets/station/tan.svg'


const _withScopeId = n => (_pushScopeId("data-v-69b55e3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "generation-stats-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "main-title" }, "节能减排", -1))
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"item-flex title\" data-v-69b55e3e><div data-v-69b55e3e></div><div data-v-69b55e3e><div class=\"title-icon\" data-v-69b55e3e><img src=\"" + _imports_0 + "\" alt=\"co2.svg\" data-v-69b55e3e></div><div data-v-69b55e3e>CO2 减排量(kg)</div></div><div data-v-69b55e3e><div class=\"title-icon\" data-v-69b55e3e><img src=\"" + _imports_1 + "\" alt=\"tree.svg\" data-v-69b55e3e></div><div data-v-69b55e3e>等效植树量(棵)</div></div><div data-v-69b55e3e><div class=\"title-icon\" data-v-69b55e3e><img src=\"" + _imports_2 + "\" alt=\"tree.svg\" data-v-69b55e3e></div><div data-v-69b55e3e>节约标准煤 kg</div></div></div>", 1)
const _hoisted_5 = { class: "item-flex bg-col" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "当日", -1))
const _hoisted_7 = { class: "value" }
const _hoisted_8 = { class: "value" }
const _hoisted_9 = { class: "value" }
const _hoisted_10 = { class: "item-flex bg-col" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "累计", -1))
const _hoisted_12 = { class: "value" }
const _hoisted_13 = { class: "value" }
const _hoisted_14 = { class: "value" }

import { GetEssEnergyConversionStats } from '@/api/evses'
import { GetEssEnergyConversionStatsReply } from '@/views/DataV/Photovoltaic/types'
import { onMounted, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const essEnergyConversionStats = ref<Partial<GetEssEnergyConversionStatsReply>>({})
const fetchEssEnergyConversionStats = () => {
  GetEssEnergyConversionStats().then((res: GetEssEnergyConversionStatsReply) => {
    essEnergyConversionStats.value = res
  })
}

onMounted(() => {
  fetchEssEnergyConversionStats()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, _toDisplayString(essEnergyConversionStats.value.dailyReduceCarbon), 1),
        _createElementVNode("div", _hoisted_8, _toDisplayString(essEnergyConversionStats.value.dailyPlantingTrees), 1),
        _createElementVNode("div", _hoisted_9, _toDisplayString(essEnergyConversionStats.value.dailyReduceCoal), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, _toDisplayString(essEnergyConversionStats.value.cumulativeReduceCarbon), 1),
        _createElementVNode("div", _hoisted_13, _toDisplayString(essEnergyConversionStats.value.equivalentPlantingTrees), 1),
        _createElementVNode("div", _hoisted_14, _toDisplayString(essEnergyConversionStats.value.cumulativeReduceCoal), 1)
      ])
    ])
  ]))
}
}

})